import { changePaxStatus } from '../../../store/dcs'

export const handleCheckInChange = (pax, dispatch, ETStatus) => {
  let editData, checkingIn = false;
  if (ETStatus === 'O') {
    checkingIn = true;
  };

  if (checkingIn) {
    editData = {newStatus: checkingIn, paxNumber: pax.PaxNumber, origin: pax.ORIGIN, destination: pax.DESTIN};
  } else { 
    editData = {newStatus: checkingIn, paxNumber: pax.PaxNumber, origin: pax.ORIGIN, destination: pax.DESTIN, couponNumber: pax.TicketCouponNumber, ticketNumber: pax.TicketNumber};
  };

  // NOTE // airlineId is added to the payload in the dcs store
  const payload = {editData, rloc: pax.PNRRefNo, type: 'checkIn'};

  dispatch(changePaxStatus(payload))
}